export default {
  completion: 'Заполнено на {{percent}}%',
  pagesValidationProgress: 'Корректных страниц: {{valid}}/{{total}} ({{percent}}%)',
  pageComplete: 'Заполнена',
  copyPath: 'Копировать путь',
  pathCopiedToClipboard: 'Путь скопирован в буфер обмена',
  subPage: 'Подстраница',
  addChildTo: 'Добавить к {{nodeDefLabel}}',
  addChildToTitle: 'Добавить новый узел к {{nodeDefLabel}}',
  addChildToTypes: {
    boolean: 'Булево',
    code: 'Код',
    coordinate: 'Координата',
    date: 'Дата',
    decimal: 'Десятичное число',
    geo: 'Геопространственные данные',
    entity: 'Таблица или форма',
    file: 'Файл',
    integer: 'Целое число',
    taxon: 'Таксон',
    text: 'Текст',
    time: 'Время',
    formHeader: 'Заголовок формы',
  },
  clone: "Клонировать '{{nodeDefLabel}}'",
  compressFormItems: "Сжать элементы формы для '{{nodeDefLabel}}'",
  confirmClearNonApplicableValues: `Следующие поля станут неактуальными, и их значения будут удалены:

{{nodeDefLabels}}

Продолжить?`,
  confirmUpdateDependentEnumeratedEntities:
    'Если вы продолжите, некоторые перечисленные сущности ({{entityDefs}}) будут перечислимы заново, удалив существующие в них значения (если таковые имеются).\nПродолжить?',
  convert: "Преобразовать '{{nodeDefLabel}}'",
  delete: "Удалить '{{nodeDefLabel}}'",
  edit: "Редактировать '{{nodeDefLabel}}'",
  schemaSummary_csv: 'Сводка схемы (CSV)',
  schemaSummary_xlsx: 'Сводка схемы (Excel)',
  schemaSummaryAiDescriptions_csv: 'Сводка схемы + описания ИИ (CSV)',
  schemaSummaryAiDescriptions_xlsx: 'Сводка схемы + описания ИИ (Excel)',
  hidePages: 'Скрыть страницы',
  showPages: 'Показать страницы',
  move: "Переместить '{{nodeDefLabel}}'",
  movePageUp: 'Переместить страницу вверх',
  movePageDown: 'Переместить страницу вниз',
  formEditActions: {
    preview: 'Предварительный просмотр',
    previewDesktop: 'Предварительный просмотр (компьютер)',
    previewMobile: 'Предварительный просмотр (мобильный)',
    previewOptions: 'Параметры предварительного просмотра',
  },
  mobilePreview: {
    device: {
      phone: 'Телефон',
      tablet: 'Планшет',
    },
    error: 'Ошибка загрузки мобильного предпросмотра: {{error}}',
    differences: `**Отличия от Arena Mobile на реальном устройстве**
- **Дата и время**: вводятся в текстовое поле (DD/MM/YYYY, HH:mm) вместо системных средств выбора даты/времени устройства
- **Карты**: недоступны (кнопки карты показывают заглушку; нет офлайн- и PDF-карт)
- **Местоположение**: берётся из браузера (обычно менее точно, чем GPS устройства); внешние GPS-приёмники не поддерживаются
- **Фото и файлы**: выбираются на компьютере; съёмка камерой и местоположение фото (EXIF) недоступны
- **Клавиатура и жесты**: физическая клавиатура и мышь вместо экранной клавиатуры и свайпов
- **Данные**: хранятся только в памяти и теряются при перезагрузке; нет списка записей, синхронизации и экспорта`,
    note: 'Приближённое отображение Arena Mobile в браузере с черновиком опроса.',
    orientation: {
      landscape: 'Альбомная',
      portrait: 'Книжная',
    },
    reload: 'Перезагрузить',
    title: 'Мобильный предпросмотр',
  },
  formEntryActions: {
    confirmDemote: 'Вы уверены, что хотите понизить статус этой записи до {{name}}?',
    confirmPromote:
      'Вы уверены, что хотите **повысить статус этой записи до {{name}}**?\nВы больше не сможете ее редактировать',
    confirmPromoteWithErrors: '**Эта запись содержит ошибки**.\n$t(surveyForm:formEntryActions.confirmPromote)',
    confirmDelete: 'Вы уверены, что хотите удалить эту запись?\n\n$t(common.cantUndoWarning)',
    closePreview: 'Закрыть предварительный просмотр',
    demoteTo: 'Понизить до {{stepPrev}}',
    promoteTo: 'Повысить до {{stepNext}}',
    step: 'Шаг {{id}} ({{name}})',
  },
  nodeDefEditFormActions: {
    columns: 'Столбцы',
    confirmConvert: 'Преобразовать атрибут "{{name}}" в "{{toType}}"?',
    confirmDelete:
      'Вы уверены, что хотите безвозвратно удалить это определение узла: {{ name }}?\n\n$t(common.cantUndoWarning)',
  },
  nodeDefCode: {
    code: '$t(common.code)',
    label: '$t(common.label)',
    typeCodeOrLabel: 'Введите код или метку',
    option: 'Вариант {{value}}',
  },
  nodeDefBoolean: {
    labelValue: {
      trueFalse: {
        true: '$t(common.true)',
        false: '$t(common.false)',
      },
      yesNo: {
        true: '$t(common.yes)',
        false: '$t(common.no)',
      },
    },
  },
  nodeDefCoordinate: {
    coordinate: 'Координата',
    srs: 'СКР',
    x: 'X',
    y: 'Y',
    showOnMap: 'Показать на карте',
    accuracy: 'Точность',
    altitude: 'Высота',
    altitudeAccuracy: 'Точность высоты',
  },
  nodeDefGeo: {
    confirmDelete: 'Удалить это геопространственное значение?',
    geoJSON: 'GeoJSON',
    invalidGeoJsonFileUploaded: 'Загружен недействительный файл GeoJSON',
  },
  nodeDefEntityForm: {
    addNewEntity: 'Добавить новую {{name}}',
    confirmDelete: 'Вы уверены, что хотите удалить эту сущность?',
    select: 'Выберите {{name}}:',
    selectedEntity: 'Выбрано {{name}}:',
  },
  nodeDefTaxon: {
    code: '$t(common.code)',
    scientificName: 'Научное название',
    vernacularName: 'Народное название',
    vernacularNameAlwaysIncludedIfSingle: 'Народное название всегда включается, если оно только одно',
    vernacularNameAlwaysIncludedIfSingleInfo: `- **Включено**: если эта опция включена и для таксона определено только одно народное название, это народное название будет автоматически сохранено в данных при выборе таксона.  
- **Отключено**: будет сохранён только код таксона и научное название, даже если у таксона есть только одно народное название.`,
    vernacularNameSelectionKept: 'Выбор народного названия сохранен',
    vernacularNameSelectionKeptInfo: `- **Включено**: когда таксон выбирается по народному (общепринятому) названию, конкретное народное название, использованное для поиска, также сохраняется в данных.  
- **Отключено**: будет сохранён только код таксона и научное название, независимо от того, какое народное название использовалось при поиске.  
В Arena Mobile:  
- **Включено**: каждое народное название отображается как отдельный элемент в списке результатов поиска.
- **Отключено**: все народные названия таксона группируются и отображаются рядом с таксоном (объединяются в одну запись). В результате список автодополнения содержит меньше элементов.`,
    visibleFields: 'Видимые поля',
  },
  nodeDefFile: {
    errorLoadingPreview: 'Ошибка загрузки предварительного просмотра',
    fileUuid: 'UUID файла',
    fileName: 'Имя файла',
    locationInformationNotFound: 'Информация о местоположении не найдена в файле',
  },
  nodeDefsTreeSelectMode: {
    allNodeDefs: 'Все узлы',
    onlyPages: 'Только страницы',
  },
  step: {
    entry: 'Ввод данных',
    cleansing: 'Очистка данных',
    analysis: 'Анализ данных',
  },
  cloneFromAnotherSurvey: {
    title: 'Клонировать узел из другой анкеты',
    expandToLoadNodes: 'Разверните, чтобы загрузить узлы',
    loadingSurveyNodes: 'Загрузка узлов анкеты...',
    errorLoadingSurveyNodes: 'Ошибка загрузки узлов анкеты',
    noNodesAvailable: 'Узлы недоступны',
    loadingSurveys: 'Загрузка анкет...',
    noSurveysAvailable: 'Анкеты недоступны',
    sourceNode: 'Исходный узел',
    targetEntityCurrentSurvey: 'Целевой объект (текущая анкета)',
  },
  confirmNodeDelete: 'Вы уверены, что хотите удалить этот {{nodeDefType}} ({{nodeDefLabel}})?',
  downloadPrintableDocument: 'Скачать печатный документ (Word)',
  downloadPrintableDocumentPdf: 'Скачать печатный документ (PDF)',
  printableExport: {
    title: 'Экспорт печатного документа',
    exportDocument: 'Экспорт документа',
    format: 'Формат',
    formats: {
      pdf: 'PDF',
      docx: 'Word',
    },
    scope: 'Содержимое',
    scopes: {
      full: 'Вся анкета',
      currentPage: 'Только текущая страница ({{entityLabel}})',
    },
    currentPageUnavailable:
      'Не удалось определить экземпляр текущей страницы. Перейдите на конкретную страницу или экспортируйте всю анкету.',
    includeQrCode: 'Включить QR-код',
    includeQrCodeInfo:
      'Добавляет QR-код на первую страницу со ссылкой на доступную только для чтения PDF-копию этой сущности (срок действия — 1 год).',
    orientation: 'Ориентация страницы',
    orientations: {
      portrait: 'Книжная',
      landscape: 'Альбомная',
    },
    download: 'Скачать',
  },
  exportLabels_csv: 'Экспорт меток (CSV)',
  exportLabels_xlsx: 'Экспорт меток (Excel)',
  importLabels: 'Импорт меток из Excel или CSV',
  aiTranslateLabels: 'ИИ: Перевести метки',
  nodeDefsTranslation: {
    apply: 'Применить переводы',
    applySuccess: 'Переводы успешно применены',
    aiSuggestion: 'ИИ',
    current: 'Текущий',
    custom: 'Пользовательский',
    defaultDescription: 'Описание по умолчанию',
    defaultLabel: 'Метка по умолчанию',
    path: 'Путь',
    showDescriptions: 'Показать описания',
    title: 'Перевести метки определений узлов',
  },
}
